
FWS.Algolia = (() => {

  const getClient = (() => {
    let instance
    return async () => {
      if (!instance) {
        const { default: AlgoliaSearch } = await import('https://cdn.jsdelivr.net/npm/algoliasearch@4.20.0/dist/algoliasearch-lite.esm.browser.js')
        instance = AlgoliaSearch('U0J0RNEHT1', '5d713ca9f05932382a221cad09213e3d')
      }
      return instance
    }
  })()

  const facetConfigs = {
    collection: {
      type: 'conjunctive',
      buildOptions() { return {} },
      buildQuery(handle) {
        return `'collections':'${handle}'`
      }
    },
    availability: {
      name: 'availability',
      title: 'availability',
      type: 'conjunctive',
      buildOptions() {
        return {
          'Show in stock only': 0
        }
      },
      buildQuery(value) {
        return `'inventory_quantity'>0`
      }
    },
    // not implemented currently
    'meta.reviews.rating.value': {
      name: 'rating', 
      title: 'rating', 
      type: 'conjunctive',
      isolatedConjunctive: true,
      buildQuery(value) {
        debugger
        return `'meta.reviews.rating.value'>=${value.charAt(0)}`
      },
      buildOptions(responseOptions) {
        debugger
        const entries = Object.entries(responseOptions)
        const calc = num => entries.filter(([ key ]) => key >= num).map(FWS.Util.last).reduce(FWS.Util.add, 0)
        return {
          '5 and up': calc(5),
          '4 and up': calc(4),
          '3 and up': calc(3),
          '2 and up': calc(2),
          '1 and up': calc(1),
        }
      },
      sortOptions(a, b) {
        return 0
      },
      renderOption(facet, option) {
        const stars = document.getElementById('stars-for-cloning')
        if (stars) {
          const clone = stars.cloneNode(true)
          const div = clone.querySelector('div')
          div.setAttribute('x-data', `{ prefix: '${facet.id}-${option.label}', average: option.label.charAt(0), customCountText: option.label }`)
          return div.outerHTML
        }
        return option.label
      }
    }
  }

  return {

    renderFacetDisplayName(id) {
      const facet = FWS.Algolia.getFacet(id)
      return facet.title
    },

    renderFacetOptionLabel(facet, option) {
      return facet.renderOption ? facet.renderOption(facet, option) : option.label
    },

    getFacet(id) {
      const facet = FWS.Liquid.algoliaFacetList.find(f => f.name === id)
      return { ...(facet || {}), ...(facetConfigs[id] || {}) }
    },

    formatResultFacets(rawFacets={}) {
      const pairs = Object.entries(rawFacets)
      const sorted = []
      const sortedFilterIds = FWS.Liquid.algoliaFacetList.map(a => a.name)
      for (let i = 0; i < pairs.length; i++) {
        const realI = sortedFilterIds.indexOf(pairs[i][0])
        sorted[realI] = pairs[i]
      }

      // always add availability
      sorted.unshift([ 'availability', facetConfigs['availability'].options ])

      return sorted
        .filter(x => !!x)
        .map(([ id, responseOptions ]) => {
          const facet = FWS.Algolia.getFacet(id)
          const options = facet.buildOptions ? facet.buildOptions(responseOptions) : responseOptions
          return {
            ...facet,
            id,
            type: facet.type,
            name: FWS.Algolia.renderFacetDisplayName(id),
            options: Object.entries(options)
              .map(([ label, count ]) => ({ label, count }))
              .sort(facet.sortOptions || ((a, b) => {
                if (a.count > b.count) 
                  return -1
                else if (a.count < b.count)
                  return 1
                return 0
              }))
          }
        })
    },

    buildFilterQuery(appliedFacets) {

      const facets = []

      for (const appliedFacet of appliedFacets) {

        const [ id, value ] = appliedFacet

        const config = facetConfigs[id] || FWS.Liquid.algoliaFacetList.find(f => f.name === id)
        const query = config?.buildQuery ? config.buildQuery(value) : `'${id}':'${value}'`

        const existing = facets.find(f => f.id === id)
        if (existing) {
          if (config.type === 'disjunctive') {
            existing.query += ` OR ${query}`
          }
          if (config.type === 'conjunctive') {
            existing.query += ` AND ${query}`
          }
          continue
        }

        facets.push({ id, query })
      }

      return facets
        .map(facet => `(${facet.query})`)
        .join(' AND ')
    },

    async search({ 
      index = 'shopify_products', 
      query='', 
      filters = '', 
      rawFilterArray = [],
      facets = [], 
      page = 0,
      distinct = true,
      facetingAfterDistinct = true,
      rules = []
    }) {

      const algolia = await getClient()

      console.log('Searching Filters: ', filters, index)
      algolia.transporter.requestsCache.clear()
      algolia.transporter.responsesCache.clear()

      const queries = []

      // actual search
      queries.push({
        indexName: index,
        query,
        params: {
          clickAnalytics: true,
          hitsPerPage: 24,
          enableRules: index === 'shopify_products',
          ruleContexts: rules,
          filters,
          facets,
          page,
          distinct,
          facetingAfterDistinct,
          maxValuesPerFacet: 1000
        }
      })

      for (const rawFilter of rawFilterArray) {
        const [ key, value ] = rawFilter
        const facet = FWS.Algolia.getFacet(key)
        if (key === 'collection' || facet.type !== 'disjunctive') continue
        queries.push({
          indexName: index,
          query,
          params: {
            clickAnalytics: true,
            filters: FWS.Algolia.buildFilterQuery(rawFilterArray.filter(rawFilter => rawFilter.key !== key)),
            facets: key,
            facetingAfterDistinct,
            distinct,
            attributesToRetrieve: [],
            hitsPerPage: 1
          }
        })

      }

      return algolia.multipleQueries(queries)
    },

    async getBySkus(skus) {
      const algolia = await getClient()
      const index = algolia.initIndex('shopify_products');
      return index.search('', {
        filters: `${skus.map(sku => `sku:${sku}`).join(' OR ')}`,
        attributesToRetrieve: [ 'handle' ]
      })
    },

    async getInventoryPolicies(ids) {
      const algolia = await getClient()
      const index = algolia.initIndex('shopify_products');
      return index.search('', {
        hitsPerPage: 100,
        filters: `${ids.map(id => `objectID:${FWS.Api.adminId(id)}`).join(' OR ')}`,
        attributesToRetrieve: [ 'inventory_policy' ]
      })
    }
  }
})()
